import React, { useEffect, useState } from "react";
import "../Helper/DatePicker/datePicker.css";
import { DatePicker } from "antd";
import { ConfigProvider } from "antd";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { formatDateNumeric } from "../Helper/DatePicker/DateFormatters";
import { getDatePickerDate } from "../Helper/DatePicker/DateConverter";
import moment from "moment";
import Cookies from "universal-cookie";

const CustomCalendar = ({
  onMouseEnter = () => {},
  onMouseLeave = () => {},
  suffixIcon = null,
  changeTheDate = () => {},
  date = [],
  popupClassName = "",
  datePickerStyle = {},
  page,
  ...restProps
}) => {
  const { RangePicker } = DatePicker;
  const cookies = new Cookies();
  const [dates, setDates] = useState(null);
  const [value, setValue] = useState(null);
  const [pickerKey, setPickerKey] = useState(0);
  let optionalProps = {}

  if (suffixIcon !== null) {
    optionalProps.suffixIcon = suffixIcon;
    optionalProps.dropdownClassName="custom-calendar-dropdown"
  }

  useEffect(() => {
    setPickerKey((prevKey) => prevKey + 1);
  }, [date[0], date[1]]);

  dayjs.extend(utc);
  dayjs.extend(timezone);
  dayjs.tz.setDefault(cookies.get("timeZone"));

  const rangePresets = [
    {
      label: "Today",
      value: [dayjs().tz(), dayjs().tz()],
    },
    {
      label: "Last 7 Days",
      value: [dayjs().tz().add(-6, "d"), dayjs().tz()],
    },
    {
      label: "Last 14 Days",
      value: [dayjs().tz().add(-13, "d"), dayjs().tz()],
    },
    {
      label: "Last 30 Days",
      value: [dayjs().tz().add(-29, "d"), dayjs().tz()],
    },
  ];

  const disabledDate = (current) => {
    var date = getDatePickerDate();
    if (date[0] === "" && date[1] === "") {
      return current && current > dayjs.tz();
    } else if (page === "digitalTwin") {
      return (
        (current && current < dayjs().tz().add(-182, "d")) ||
        current > moment(date, "YYYY-MM-DD")
      );
    } else {
      return current && current > moment(date, "YYYY-MM-DD");
    }
  }

  const onOpenChange = (open) => {
    if (restProps.onOpenChange) {
      restProps.onOpenChange(open);
    }

    if (dates) {
      if (dates[0] && !dates[1]) {
        setDates([dates[0], dates[0]]);
      } else if (!dates[0] && dates[1]) {
        setDates([dates[1], dates[1]]);
      }
    }
  };

  useEffect(() => {
    const start =
      date[0] === undefined || date[0] === ""
        ? null
        : dayjs(date[0], "YYYY-MM-DD");
    const end =
      date[1] === undefined || date[1] === ""
        ? null
        : dayjs(date[1], "YYYY-MM-DD");
    setValue([start, end]);
    if (start === null && end === null) {
      setDates(null);
    } else {
      setDates([start, end]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date[0], date[1]]);

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#4F44E0",
        },
      }}
    >
      <RangePicker
        key={pickerKey}
        format={"DD MMM YYYY"}
        value={dates || value}
        presets={restProps.rangePresets || rangePresets}
        separator={<div style={{ marginRight: "8px", padding: "0" }}>-</div>}
        inputReadOnly={true}
        popupClassName={popupClassName}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        allowClear={false}
        dropdownClassName="custom-calendar-dropdown"
        onCalendarChange={(val) => {
          setDates(val);
          onMouseLeave()

          if (val) {
            if (val[0] && val[1]) {

              changeTheDate(
                formatDateNumeric(val[0]["$d"]),
                formatDateNumeric(val[1]["$d"])
              );
            } else if (!val[0] && val[1]) {
              changeTheDate(
                formatDateNumeric(val[1]["$d"]),
                formatDateNumeric(val[1]["$d"])
              );
            } else if (val[0] && !val[1]) {
              changeTheDate(
                formatDateNumeric(val[0]["$d"]),
                formatDateNumeric(val[0]["$d"])
              );
            } else {
              changeTheDate("", "");
            }
          } else {
            changeTheDate("", "");
            setValue(null);
            setDates(null);
          }
        }}
        onOpenChange={onOpenChange}
        disabledDate={restProps.disabledDate || disabledDate}
        {...optionalProps}
      />
    </ConfigProvider>
  );
};

export default CustomCalendar;
